namespace Matrix.Data {
    export class SecurityValueColumns {
        static columnsKey = 'Data.SecurityValue';
    }
}
